export interface ISendToCustomerContactState {
  contactName: string;
  contactPhone: string;
  contactMail: string;
  additionalEmailCc: string;
  sendBySms: boolean;
  sendByMail: boolean;
  sendByWhatsapp: boolean;
  documentContacts: Array<{
    id?: string;
    contactID?: string;
    contactName?: string;
    contactMail?: string;
    contactPhone?: string;
    mail?: string;
    email?: string;
    phone?: string;
    name?: string;
  }>;
  selectedContactIndex: number;
}

export const createInitialSendToCustomerContactState = (
  overrides?: Partial<ISendToCustomerContactState>
): ISendToCustomerContactState => ({
  contactName: "",
  contactPhone: "",
  contactMail: "",
  additionalEmailCc: "",
  sendBySms: true,
  sendByMail: true,
  sendByWhatsapp: true,
  documentContacts: [],
  selectedContactIndex: 0,
  ...overrides,
});
